export default "__VITE_ASSET__cBa$he97__"